import { LANGUAGES } from './valamar-theme';

export default function LanguageSelector({ value, onChange }) {
  return (
    <select
      className="demo-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Select language"
    >
      {LANGUAGES.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {lang.flag} {lang.label}
        </option>
      ))}
    </select>
  );
}
